
    import '/vercel/path0/docs/demo/bootstrap.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-demo-bootstrap-demo-bootstrap"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/bootstrap.md?type=demo')
};